// extracted by mini-css-extract-plugin
export default {"author":"_704c81db","authorInfo":"_5d095655","authorLogo":"_fd5b54b0","expertLogo":"_ec136feb"};